<div class="auth-wrapper d-flex no-block justify-content-center align-items-center"
     [style]="environment.loginbgPath.charAt(0) == '#'? ('background-color: ' + environment.loginbgPath) : ('background-image:url('+ environment.loginbgPath +')')">
  <div class="auth-box m-3 m-md-0">
    <div >
      <div class="logo">
        <h5 class="font-medium m-b-20">Cambio Password</h5>
        <h5 class="m-b-20">Per ragioni di sicurezza é necessario Cambiare la password dell'utente</h5>
      </div>
      <div class="row m-t-20">
        <div class="col-12">
          <div class="form-group row">
            <div class="col-12">
              <input [(ngModel)]="Password" class="form-control form-control-lg" type="password" required placeholder="Password">
            </div>
          </div>
          <div class="form-group row">
            <div class="col-12">
              <input [(ngModel)]="ConfermaPassword" class="form-control form-control-lg" type="password" required placeholder="Conferma Password">
            </div>
          </div>
          <div class="row m-t-20">
            <div class="col-12">
              <button class="btn btn-block btn-lg btn-info" type="submit" (click)="Change()" name="action">Avanti</button>
            </div>
            <div class="col-12">
              <button class="btn btn-block btn-lg btn-danger" type="submit" (click)="Annulla()" name="action">Annulla</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
